import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import StatusBadge, { STATUS_LIST } from './components/StatusBadge'
import { listInbox } from './api/issuesApi'
import { useAuth } from '../services/authProvider'

function fmt(ts) {
  if (!ts) return ''
  return new Date(ts).toLocaleString('th-TH', { dateStyle: 'short', timeStyle: 'short' })
}

const TABS = [
  { value: '',            label: 'ทั้งหมด' },
  { value: 'new',         label: 'ใหม่' },
  { value: 'received',    label: 'รับเรื่อง' },
  { value: 'in_progress', label: 'กำลังดำเนินการ' },
  { value: 'done',        label: 'เสร็จสิ้น' },
]

export default function IssueInbox() {
  const { posIds = [] } = useAuth() || {}
  const isAdmin = posIds.includes(99)
  const [rows, setRows] = useState([])
  const [total, setTotal] = useState(0)
  const [status, setStatus] = useState('')
  const [page, setPage] = useState(1)
  const [q, setQ] = useState('')
  const [loading, setLoading] = useState(true)
  const pageSize = 20

  const load = async () => {
    setLoading(true)
    try {
      const data = await listInbox({ page, pageSize, status, q })
      setRows(data.rows || [])
      setTotal(data.total || 0)
    } catch (err) {
      console.error(err)
      setRows([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { load() /* eslint-disable-next-line */ }, [page, status])

  const onSearch = (e) => { e.preventDefault(); setPage(1); load() }
  const totalPages = Math.max(1, Math.ceil(total / pageSize))

  return (
    <div className="main main-app p-3 p-lg-4" style={{ maxWidth: 1200 }}>
      <div className="d-flex align-items-center gap-2 mb-3">
        <i className="ri-inbox-line fs-3 text-primary" />
        <h4 className="mb-0">กล่องรับเรื่อง (ฝ่ายของคุณ)</h4>
      </div>

      <ul className="nav nav-pills mb-3 flex-nowrap overflow-auto" style={{ whiteSpace: 'nowrap' }}>
        {TABS.map(t => (
          <li key={t.value || 'all'} className="nav-item">
            <button
              type="button"
              className={'nav-link ' + (status === t.value ? 'active' : '')}
              onClick={() => { setStatus(t.value); setPage(1) }}
            >
              {t.label}
            </button>
          </li>
        ))}
      </ul>

      <div className="card mb-3">
        <div className="card-body py-2">
          <form className="row g-2" onSubmit={onSearch}>
            <div className="col-12 col-md">
              <input
                type="search"
                className="form-control"
                placeholder="ค้นหารหัส/หัวข้อ/รายละเอียด..."
                value={q}
                onChange={e => setQ(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-auto">
              <button className="btn btn-outline-primary w-100" type="submit">
                <i className="ri-search-line me-1" />ค้นหา
              </button>
            </div>
          </form>
        </div>
      </div>

      {loading
        ? <div className="text-center py-5"><span className="spinner-border" /></div>
        : rows.length === 0
          ? <div className="text-center py-5 text-muted">ไม่มีรายการในกล่องนี้</div>
          : (
            <div className="d-flex flex-column gap-2">
              {rows.map(r => (
                <Link
                  key={r.ir_id}
                  to={`/issues/detail/${r.ir_id}`}
                  className="card text-decoration-none text-body card-hover"
                >
                  <div className="card-body py-3">
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <i className={`${r.cat_icon} text-primary`} />
                      <span className="small text-muted">{r.ir_code}</span>
                      <StatusBadge status={r.ir_status} className="ms-auto" />
                    </div>
                    <div className="fw-semibold mb-1">{r.ir_title}</div>
                    <div className="small text-muted d-flex flex-wrap gap-2 align-items-center">
                      <span><i className="ri-folder-line me-1" />{r.cat_name}</span>
                      <span><i className="ri-building-line me-1" />{r.dept_name}</span>
                      {r.ir_location && (<span><i className="ri-map-pin-line me-1" />{r.ir_location}</span>)}
                      <span><i className="ri-user-line me-1" />{isAdmin ? r.submitter_name : 'xxxx xxx'}
                        {isAdmin && r.submitter_role === 'student' ? ' (นักเรียน)' : ''}
                      </span>
                      {r.attachment_count > 0 && (<span><i className="ri-image-line me-1" />{r.attachment_count}</span>)}
                      <span className="ms-auto">{fmt(r.ir_created_at)}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )
      }

      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-3 gap-2">
          <button className="btn btn-outline-secondary btn-sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>
            <i className="ri-arrow-left-s-line" />
          </button>
          <span className="align-self-center small">หน้า {page} / {totalPages} (ทั้งหมด {total})</span>
          <button className="btn btn-outline-secondary btn-sm" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>
            <i className="ri-arrow-right-s-line" />
          </button>
        </div>
      )}
    </div>
  )
}
